import { brand1, brand2, brand3, brand4 } from "../assets"

const dataBrand = [
    {
        id: 'prenn',
        name: 'Tea Resort Prenn',
        descriptions: 'resort',
        location: 'Đà Lạt, Lâm Đồng',
        thumb: brand1,
    },
    // {
    //     id: 'tea_reasort',
    //     name: 'Tea Resort Bảo Lộc',
    //     descriptions: 'resort',
    //     location: 'Bảo Lộc, Lâm Đồng',
    //     thumb: brand2,
    // },
    // {
    //     id: 'soi_island',
    //     name: 'Sỏi Island',
    //     descriptions: 'resort',
    //     location: 'Nha Trang, Khánh Hòa',
    //     thumb: brand3,

    // },
    // {
    //     id: 'nha_may_che',
    //     name: 'Nhà máy chè 1927',
    //     descriptions: 'resort',
    //     location: 'Bảo Lộc, Lâm Đồng',
    //     thumb: brand4,

    // },
]

const monthNames = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
};


function isLeapYear(year) {
    // Kiểm tra năm nhuận
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
}

function ADJUST_DATE(day, month, year) {
    // Ngày tối đa của từng tháng
    const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Điều chỉnh số ngày cho tháng 2 nếu là năm nhuận
    if (isLeapYear(year)) {
        daysInMonth[1] = 29;
    }

    // Kiểm tra và điều chỉnh tháng
    if (month < 1) month = 1;
    if (month > 12) month = 12;

    // Kiểm tra và điều chỉnh ngày
    const maxDay = daysInMonth[month - 1];
    if (day < 1) day = 1;
    if (day > maxDay) day = maxDay;

    return { day, month };
}

const TIME_REFRESH_QR = 600

const URL_SOCIAL_FACEBOOK = 'https://www.facebook.com/DoiDepTeaGarden'
const URL_SOCIAL_INSTAGRAM = 'https://www.instagram.com/doidep_vn'
const URL_SOCIAL_YOUTUBE = 'https://www.youtube.com/channel/UCFJw2YMfsQVrye82j0PP31A/featured'

export { dataBrand, monthNames, URL_SOCIAL_FACEBOOK, URL_SOCIAL_INSTAGRAM, URL_SOCIAL_YOUTUBE, ADJUST_DATE, TIME_REFRESH_QR }